<template>
    <!-- Available and waitlist share the brand color; their line patterns distinguish them. -->
    <svg
        class="h-1 w-5 shrink-0"
        :class="{
            'text-primary-500': status === 'available' || status === 'waitlist',
            'text-gray-400':
                status === 'fullOrClosed' || status === 'notOpenYet'
        }"
        viewBox="0 0 24 4"
        preserveAspectRatio="none"
        fill="none"
        stroke="currentColor"
        aria-hidden="true"
        focusable="false"
    >
        <!-- Solid bars retain the familiar underline for available and not-yet-open dates. -->
        <rect
            v-if="status === 'available' || status === 'notOpenYet'"
            width="24"
            height="4"
            fill="currentColor"
            stroke="none"
        />
        <!-- Three square-capped points keep the closed marker count and size fixed as cells stretch. -->
        <path
            v-else-if="status === 'fullOrClosed'"
            d="M4 2h0m8 0h0m8 0h0"
            stroke-width="4"
            stroke-linecap="square"
            vector-effect="non-scaling-stroke"
        />
        <!-- Three round-capped points keep the dot count fixed at every calendar width. -->
        <path
            v-else
            d="M4 2h0m8 0h0m8 0h0"
            stroke-width="4"
            stroke-linecap="round"
            vector-effect="non-scaling-stroke"
        />
    </svg>
</template>

<script setup lang="ts">
import type { CalendarAvailability } from './calendar-availability'

defineProps<{
    status: CalendarAvailability
}>()
</script>
